export const ICS_URL = `${process.env.REACT_APP_BACKEND_URL}/api/calendar.ics`;

export function googleCalUrl(s) {
  if (!s || !s.date) return "#";
  const [y, m, d] = s.date.split("-");
  const [hh = "09", mm = "00"] = (s.time || "09:00").split(":");
  const start = `${y}${m}${d}T${hh}${mm}00`;
  const startMs = Date.UTC(+y, +m - 1, +d, +hh, +mm);
  const endD = new Date(startMs + (s.duration_min || 45) * 60000);
  const pad = (n) => String(n).padStart(2, "0");
  const end = `${endD.getUTCFullYear()}${pad(endD.getUTCMonth() + 1)}${pad(endD.getUTCDate())}T${pad(endD.getUTCHours())}${pad(endD.getUTCMinutes())}00`;
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: `Paws N Poses — ${s.park_name}`,
    dates: `${start}/${end}`,
    details: `${s.notes || ""} · 45-min myofascial yoga for pets & parents`,
    location: `${s.address || ""} ${s.city || ""}`.trim(),
    ctz: "America/Denver",
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}
